'use strict';
var base = require('./base');

/**
 * Finds the needle in the haystack
 * Alternative to indexOf, since we don't support the native ES6 .includes method
 * 
 * @param {object} haystack 
 * @param {string} needle 
 * @returns {boolean}
 */
function includes(haystack, needle) {
    return haystack.indexOf(needle) !== -1;
}

/**
 * Generates the url for the button to redirect to cart and for the button to redirect to login
 *
 * @param {object} currentElement the variation btn that is currently selected
 */
function setDonationUrl(currentElement, pid, customAmount) {
    if (currentElement !== undefined) {
        // logic to build out donate/login link
        var toCart = $('.donation-to-cart-url').val();
        var toLogin = $('.donation-to-login-url').val();
        // Donation Modal in cart, for when Donation is not in basket
        var isModal =
            document.getElementsByClassName('cart-donate-menu').length > 0;
        var donateCartClassName = '';
        var donateLoginClassName = '';
        if (isModal) {
            donateCartClassName = '.donate-to-cart-modal';
            donateLoginClassName = '.donation-to-login-modal';
            pid = currentElement.data('attr-value');
        } else {
            donateCartClassName = '.donate-to-cart';
            donateLoginClassName = '.donation-to-login';
            if (pid === '') {
                pid = $('.product-detail:not(".bundle-item")').data('pid');
            } else {
                $('.product-detail:not(".bundle-item")').data('pid', pid);
            }
        }
        var btnOtherElement = document.getElementsByClassName('btn-other');
        var customAmountString = '';
        if (
            customAmount !== undefined &&
            customAmount !== null &&
            customAmount !== ''
        ) {
            customAmountString = 'custom,' + customAmount + ',';
        } else if (
            btnOtherElement !== undefined &&
            btnOtherElement.length > 0 &&
            includes(btnOtherElement[0].className, 'js-info-active')
        ) {
            customAmountString =
                'custom,' + $('.donation-other-amount').val() + ',';
        }
        $(donateCartClassName).attr(
            'href',
            toCart + '?' + getRedirectParameterString(pid, customAmountString)
        );
        $(donateLoginClassName).attr(
            'href',
            toLogin +
            '?rurl=4&' +
            getRedirectParameterString(pid, customAmountString)
        );

        // disable button if missing variation or custom amount
        if (!/\d/.test(pid) && !customAmountString) {
            $(donateCartClassName).addClass('disabled');
            $(donateLoginClassName).addClass('disabled');
        }

        var pushAddToCartToDataLayer = function () {
            var otherAmount = $('.donation-other-amount').val();

            var price = otherAmount
                ? otherAmount
                : (currentElement.length ? currentElement[0] : currentElement)
                    .dataset.attrValue;

            dataLayerHandler.pushToDataLayerWithClient({
                event: 'addToCart',
                ecommerce: {
                    currencyCode: 'USD', // TODO: DL do not hardcode this.
                    add: {
                        products: [
                            {
                                name: 'Join in this Mission',
                                id: pid,
                                price: price,
                                brand: 'donation',
                                category: 'Donations',
                                variant: false,
                                quantity: 1,
                            },
                        ],
                    },
                },
            });
        };

        $(donateCartClassName).off();
        $(donateLoginClassName).off();

        $(donateCartClassName).on('click', pushAddToCartToDataLayer);
        $(donateLoginClassName).on('click', pushAddToCartToDataLayer);
    }
}

/**
 *	Sets up the redirect url with the given parameters
 *
 * @param {String} productId the selected product id
 * @param {String} customAmount custom amount value
 */
function getRedirectParameterString(productId, customAmount) {
    return 'redirect=pid,' + productId + ',qty,1,' + customAmount + 'atc,true';
}

function getProductIdAndSetDonationUrl(currentElement) {
    if (currentElement !== undefined) {
        $.ajax({
            url: currentElement.val(),
            method: 'GET',
            success: function (data) {
                setDonationUrl(currentElement, data.product.id, '');
            },
        });
    }
}

/**
 * Displays Login button if user is not logged in and donation type is reoccuring
 *
 * @param {object} btnValue the value of the variation btn that is currently selected
 */
function determineWhichButtonToDisplay(btnValue, atcButton) {
    if (btnValue !== undefined) {
        var isUserLoggedIn = $('.is-user-logged').val() === 'true';
        var btnClassList = document.getElementsByClassName(atcButton);
        var donateButtonClassList =
            document.getElementsByClassName('donation-to-login');

        if (
            !isUserLoggedIn &&
            btnValue !== undefined &&
            btnValue.length > 0 &&
            (includes(btnValue, 'monthly') || includes(btnValue, 'annual'))
        ) {
            if (
                btnClassList !== undefined &&
                btnClassList.length > 0 &&
                !includes(btnClassList[0].className, 'hidden')
            ) {
                $('.' + atcButton).addClass('hidden');
            }
            $('.donation-to-login').removeClass('hidden');
        } else {
            if (
                donateButtonClassList !== undefined &&
                donateButtonClassList.length > 0 &&
                !includes(donateButtonClassList[0].className, 'hidden')
            ) {
                $('.donation-to-login').addClass('hidden');
            }
            $('.' + atcButton).removeClass('hidden');
        }
    }
}

module.exports = {
    availability: base.availability,
    attributeSelect: base.attributeSelect,
    addToCart: base.addToCart,
    buttonAttribute: base.buttonAttribute,
    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $(
                '.product-detail[data-pid="' + data.id + '"]'
            );

            $productContainer
                .find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer
                    .find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer
                    .find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer
                    .find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer
                    .find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer
                    .find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer
                    .find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on(
            'product:beforeAddToCart product:beforeAttributeSelect',
            function () {
                $.spinner().start();
            }
        );
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container
                    .find('.product-id')
                    .text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container
                    .find('.product-id')
                    .text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data(
                    'pid',
                    response.data.product.id
                );
            }
        });
    },

    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty()
                .html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability')
                    .toArray()
                    .every(function (item) {
                        return $(item).data('available');
                    });

                var allReady = $('.product-availability')
                    .toArray()
                    .every(function (item) {
                        return $(item).data('ready-to-order');
                    });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg')
                    .empty()
                    .html(
                        allReady
                            ? response.message
                            : response.resources.info_selectforstock
                    );
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this)
                .closest('.size-chart')
                .find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    },
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },

    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },
    selectDefaultAttribute: function () {
        var items = document.getElementsByClassName('btn-variation-attribute');
        for (var i = 0; i < items.length; i++) {
            if (items[i].attributes.selected) {
                items[i].classList.remove('btn-outline-info');
                items[i].classList.add('btn-info');
                items[i].classList.add('js-info-active');
                $('.donate-to-cart').removeClass('disabled');
                var btnValue = $(items[i]).val();

                determineWhichButtonToDisplay(btnValue, 'donate-to-cart');

                // logic to build out donate/login link
                setDonationUrl(items[i], '', '');
            }
        }
    },

    toggleCanadaPrices: function () {
        $('body').on('click', '.price-table-toggle', function () {
            console.log('Clicked price-table-toggle.');
            $('#canada-pricing-container').toggleClass('active');
            $(this).toggleClass('active');
        });
    },

    toggleUsPrices: function () {
        $('body').on('click', '.price-table-toggle-us', function () {
            console.log('Clicked price-table-toggle-us.');
            $('#us-pricing-container').toggleClass('active');
            $(this).toggleClass('active');
        });
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    determineWhichButtonToDisplay: determineWhichButtonToDisplay,
    getProductIdAndSetDonationUrl: getProductIdAndSetDonationUrl,
    setDonationUrl: setDonationUrl,
};
